import React from "react";

const AlertBox = ({ type, title, content }) => {
    return <article className={`alertbox alertbox--${type}`}>
        <h2 className="alertbox__ttl">{title}</h2>
        <p className="alertbox__desc">{content}</p>
    </article>
};

export default AlertBox;